import script from "./editSnBlacklist.vue?vue&type=script&lang=ts&setup=true"
export * from "./editSnBlacklist.vue?vue&type=script&lang=ts&setup=true"

import "./editSnBlacklist.vue?vue&type=style&index=0&id=764faae0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764faae0"]])

export default __exports__